import { equals } from 'ramda';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { PageLoader } from '~components/Page';

import { boundActions, selectors } from '~store';

export const ImageInTooltip = ({ id }: { id: number }) => {
  const image = useSelector(selectors.assets.getImage, equals);
  const { image: isLoading } = useSelector(selectors.assets.getAssetsLoaders, equals);

  useEffect(() => {
    boundActions.assets.fetchAssetsImageByIdInit({ id });
  }, [id]);

  if (isLoading) {
    return <PageLoader />;
  }

  if (!image?.image) {
    return null;
  }

  return (
    <img
      src={`data:image/;base64,${image?.image}`}
      style={{ width: 600, height: 400, objectFit: 'contain' }}
    />
  );
};

